import { render, staticRenderFns } from "./ModificarUsuario.vue?vue&type=template&id=900034a4&scoped=true&"
import script from "./ModificarUsuario.vue?vue&type=script&lang=js&"
export * from "./ModificarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900034a4",
  null
  
)

export default component.exports